import React from 'react';

/**
 * Shared "no results for this period" illustrations used across the app's
 * empty states (AgentMonthlyMetric, AgentPieChart, NonPayoutMetricsPanel,
 * MetricDashboard). Kept together in one file since they're small, related,
 * and always change together when the design is refreshed.
 */

/**
 * Sad folder illustration. Sourced from public/FolderPurple.png.
 */
export const SadFolderIllustration: React.FC = () => (
    <img
        src={`${process.env.PUBLIC_URL}/FolderPurple.png`}
        alt=""
        aria-hidden="true"
        style={{ width: '110px', height: 'auto' }}
    />
);

/**
 * Striped "tent" illustration, used in AgentPieChart's empty state (stands
 * in for the missing pie chart). Sourced from public/BooksOrange.png.
 */
export const MetricAttainmentIllustration: React.FC = () => (
    <img
        src={`${process.env.PUBLIC_URL}/BooksOrange.png`}
        alt=""
        aria-hidden="true"
        style={{ width: '104px', height: 'auto' }}
    />
);
